export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-[72px] overflow-hidden bg-background-50">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/60 via-background-50 to-background-100/40"></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16 py-16 md:py-20">
          <div className="flex-1 w-full text-center lg:text-left z-10">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              <span className="text-xs text-primary-400 whitespace-nowrap">动作片 · 喜剧片 · 最新大片</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-100 font-bold leading-tight mb-3">
              悟空影视
              <span className="block text-primary-500 text-xl sm:text-2xl md:text-3xl lg:text-4xl mt-2">
                高清电影免费在线观看平台
              </span>
            </h1>

            <p className="text-base md:text-lg text-primary-400/90 font-medium mb-5">
              即点即播，无需缓冲
            </p>

            <p className="text-sm md:text-base text-foreground-400 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              悟空影视电影大全为您精选海量影视资源，涵盖悟空影视最新电影、动作片、喜剧片等热门题材。平台每日更新片库，从经典佳作到最新大片，高清画质流畅播放，为影迷打造一站式的在线观影体验。无论您钟爱紧张刺激的动作巨制，还是轻松诙谐的喜剧佳片，悟空影视都能满足您的多样化观影需求。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400 font-bold">20000+</div>
                <div className="text-xs text-foreground-500 mt-1">影片资源</div>
              </div>
              <div className="w-px h-10 bg-background-300/60"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400 font-bold">4K</div>
                <div className="text-xs text-foreground-500 mt-1">超清画质</div>
              </div>
              <div className="w-px h-10 bg-background-300/60"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400 font-bold">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">片库持续扩增</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-md hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line"></i>
                立即探索热播榜
              </a>
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-6 py-3 border border-secondary-300 text-foreground-200 font-medium rounded-md hover:border-primary-400 hover:text-primary-400 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-hashtag"></i>
                浏览话题热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none flex justify-center z-10">
            <div className="relative w-[280px] h-[380px] sm:w-[320px] sm:h-[440px] md:w-[360px] md:h-[500px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20collage%20with%20warm%20golden%20and%20amber%20tones%2C%20abstract%20film%20reel%20and%20spotlight%20elements%2C%20dark%20theater%20atmosphere%2C%20dramatic%20lighting%20with%20lens%20flares%2C%20minimalist%20composition%20with%20negative%20space%2C%20elegant%20typography-friendly%20layout%2C%20cinematic%20color%20grading%20with%20rich%20contrast%2C%20professional%20movie%20industry%20aesthetic%2C%20warm%20spotlight%20on%20dark%20background%2C%20film%20noir%20inspired%20mood&width=720&height=1000&seq=wukong-hero-main&orientation=portrait"
                alt="悟空影视 - 高清电影在线观影平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 via-transparent to-transparent"></div>

              <div className="absolute top-4 right-4 bg-background-50/80 backdrop-blur-sm rounded-md px-3 py-1.5">
                <span className="text-xs text-accent-400 font-semibold">今日热播</span>
              </div>
              <div className="absolute bottom-6 left-6 right-6">
                <p className="text-sm text-foreground-100 font-semibold">暑期档大片持续更新</p>
                <p className="text-xs text-foreground-300 mt-1">动作片 · 喜剧片 · 科幻片</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}